import { useEffect, useState } from 'react';
import './Insta.css';
import instApi from '../../../assets/api/InstApi';
import { INST_URL } from '../../../assets/utils/constants';
import useWindowSize from '../../../assets/hooks/useWindowSize';

function Insta() {
    const { width } = useWindowSize()
    const [data, setData] = useState(null)
    useEffect(() => {
        instApi.getPosts({ limit: 6 })
            .then((res) => {
                console.log(res.posts)
                setData(res.posts)
            })
            .catch((err) => {
                console.log(err)
            })
    }, [])
    return (
        <div className='insta'>
            <p className='insta__title'>Follow us on Instagram</p>
            <div className='insta__items'>
                {data && data.length > 0 ?
                    data.slice(0, width > 730 ? 3 : 4).map((item, i) => (
                        <a className='insta__item' href={item.url} target='_blank' rel='noreferrer'>
                            <img className='insta__item-img' src={`${INST_URL}/get-file/${item.image}`} alt='' />
                            <svg className='insta__item-play' width="26" height="30" viewBox="0 0 26 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M24.9611 16.7365C26.3048 15.9687 26.3048 14.0313 24.9611 13.2635L2.99228 0.709877C1.65897 -0.052018 0 0.910716 0 2.44636V27.5536C0 29.0893 1.65896 30.052 2.99228 29.2901L24.9611 16.7365Z" fill="white" />
                            </svg>
                            <div className='insta__item-caption'>
                                <p className='insta__item-caption-text'>{item.caption}</p>
                            </div>
                        </a>
                    ))
                    : null}
            </div>
        </div>
    );
}

export default Insta